module.exports = __webpack_public_path__ + "img/notif-msg-icon.e660b79b.svg";